<template>
  <div class="row">
    <div class="col-12 col-sm-12 px-0">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1 px-0 py-0">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <i
              class="fas fa-info-circle ml-2 info-navbar-toggler"
              id="tt-other-charges"
              :style="{ left: positionInfoToggle + 'px' }"
            ></i>
            <b-navbar-toggle target="other-changes" class="title-card">
              <template #default="{ expanded }">
                <span id="mainTitle_other_charges"
                  >Other Charges

                  <b-tooltip target="tt-other-charges" placement="right">
                    Other Charges are one-time charges for cancellations, early
                    upgrade fees, administrative fees, and other non-usage
                    related charges.
                  </b-tooltip>
                </span>
                <i class="far fa-angle-up" v-if="expanded"></i>
                <i class="far fa-angle-down" v-else></i>
              </template>
            </b-navbar-toggle>
          </b-card-header>
          <b-collapse
            id="other-changes"
            accordion="other-changes"
            role="tabpanel"
          >
            <b-card-body>
              <div class="row">
                <div class="col-12 col-sm-12">
                  <grid-loader
                    class="expertel-loader"
                    color="#ff502d"
                    :loading="loading"
                    :size="20"
                    sizeUnit="px"
                  ></grid-loader>
                </div>
              </div>
              <div v-if="data_completed === true">
                <table class="dashboard-table">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th class="text-center">Carrier</th>
                      <th class="text-center">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(line, key) in lines.data.slice(0, 5)"
                      :key="key"
                    >
                      <td>
                        {{ line.name }} <br /><strong>{{
                          line.phone | phoneNumber
                        }}</strong>
                      </td>
                      <td class="text-center">
                        <img
                          :src="
                            `https://api.expertel.ca/dist/images/${line.carrier}.svg`
                          "
                          class="img-fluid carrier-img"
                        />
                      </td>
                      <td class="text-center slim-info-td">
                        {{ line.amount }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p class="mt-3 mb-0 text-right">
                  <a
                    :href="reportMeta.csv_url"
                    target="_blank"
                    class="link mr-3"
                    ><strong>Download CSV</strong></a
                  >
                  <button class="link" v-b-modal.modalOTTCH>
                    <strong>View All</strong>
                  </button>
                </p>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>

    <!-- [[ MODAL ]] -->
    <b-modal id="modalOTTCH" size="xl" centered scrollable class="card">
      <template #modal-header="{ close }">
        <h3 class="font-circular-book mx-auto">Other Changes</h3>
        <!-- Emulate built in modal header close button action -->
        <b-button size="sm" variant="outline-expertel" @click="close()">
          <i class="fas fa-times    "></i>
        </b-button>
      </template>
      <div class="row">
        <div class="col-12 col-sm-12">
          <!--- [[ TABLE]] -->
          <table class="dashboard-table">
            <thead>
              <tr>
                <th>User</th>
                <th class="text-center">Carrier</th>
                <th class="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(line, key) in lines.data" :key="key">
                <td>
                  {{ line.name }} <br /><strong>{{
                    line.phone | phoneNumber
                  }}</strong>
                </td>
                <td class="text-center">
                  <img
                    :src="
                      `https://api.expertel.ca/dist/images/${line.carrier}.svg`
                    "
                    class="img-fluid carrier-img"
                  />
                </td>
                <td class="text-center">
                  <strong>{{ line.amount }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template #modal-footer="{ close }">
        <div class="w-100">
          <button
            aria-label="Close"
            type="button"
            class="float-right button-expertel"
            @click="close()"
          >
            Close
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["login_data", "id_report"],
  data() {
    return {
      lines: [],
      data_completed: false,
      loading: true,
      reportMeta: [],
      positionInfoToggle: 0
    };
  },
  watch: {
    id_report: function(newVal) {
      this.getData(newVal);
    }
  },
  mounted() {
    let width = document.getElementById("mainTitle_other_charges").offsetWidth;
    this.positionInfoToggle = width + 15;
  },
  created() {
    if (this.id_report !== "") {
      this.getData(this.id_report);
    }
  },
  methods: {
    getData(id_report) {
      const self = this;
      this.axios({
        method: "get",
        url: `https://api.expertel.ca/api/v1/client/me/reports/${id_report}/data?type=other_charges`,
        responseType: "json",
        headers: {
          Authorization: "Bearer " + self.login_data.token
        }
      })
        .then(function(response) {
          self.reportMeta = response.data.meta;
          self.lines = response.data;
          self.data_completed = true;
          self.loading = false;
          //sort((a, b) => a.relative - b.relative)
        })
        .catch(error => (console.log(error), alert(error)));
    }
  }
};
</script>
